var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "controlItem"
  }, [_c("div", {
    staticClass: "contBox"
  }, [_vm.item2.partsType == "singleLine" ? _c("div", {
    staticClass: "nameBox"
  }, [_vm.item2.isRequired ? _c("span", {
    staticClass: "itamNav"
  }, [_vm._v("*")]) : _vm._e(), _vm._v(_vm._s(_vm.$t(_vm.item2.controlName)) + " "), _c("a-tooltip", [_c("template", {
    slot: "title"
  }, [_vm._v(" " + _vm._s(_vm.$t(_vm.item2.controlExplain)) + " ")]), _vm.item2.controlExplain ? _c("a-icon", {
    staticStyle: {
      margin: "0 3px"
    },
    attrs: {
      type: "question-circle"
    }
  }) : _vm._e()], 2), _c("div", [_c("span", [_vm._v(_vm._s(_vm.$t(_vm.item2.prefix)))]), _c("a-input", {
    style: {
      width: _vm.item2.widthSet
    },
    attrs: {
      placeholder: _vm.$t(_vm.item2.promptText),
      readOnly: true
    }
  }), _c("span", [_vm._v(_vm._s(_vm.$t(_vm.item2.suffix)))])], 1)], 1) : _vm._e(), _vm.item2.partsType == "multiline" ? _c("div", {
    staticClass: "nameBox"
  }, [_vm.item2.isRequired ? _c("span", {
    staticClass: "itamNav"
  }, [_vm._v("*")]) : _vm._e(), _vm._v(_vm._s(_vm.$t(_vm.item2.controlName)) + " "), _c("a-tooltip", [_c("template", {
    slot: "title"
  }, [_vm._v(" " + _vm._s(_vm.$t(_vm.item2.controlExplain)) + " ")]), _vm.item2.controlExplain ? _c("a-icon", {
    staticStyle: {
      margin: "0 3px"
    },
    attrs: {
      type: "question-circle"
    }
  }) : _vm._e()], 2), _c("div", [_c("a-input", {
    style: {
      width: _vm.item2.widthSet
    },
    attrs: {
      type: "textarea",
      placeholder: _vm.$t(_vm.item2.promptText),
      readOnly: true
    }
  })], 1)], 1) : _vm._e(), _vm.item2.partsType == "singleChoice" ? _c("div", {
    staticClass: "nameBox"
  }, [_vm.item2.isRequired ? _c("span", {
    staticClass: "itamNav"
  }, [_vm._v("*")]) : _vm._e(), _vm._v(_vm._s(_vm.$t(_vm.item2.controlName)) + " "), _c("a-tooltip", [_c("template", {
    slot: "title"
  }, [_vm._v(" " + _vm._s(_vm.$t(_vm.item2.controlExplain)) + " ")]), _vm.item2.controlExplain ? _c("a-icon", {
    staticStyle: {
      margin: "0 3px"
    },
    attrs: {
      type: "question-circle"
    }
  }) : _vm._e()], 2), _c("el-row", {
    staticStyle: {
      "line-height": "40px",
      display: "flex",
      "flex-wrap": "wrap"
    },
    attrs: {
      gutter: 20
    }
  }, _vm._l(_vm.item2.controlValue, function (item1, index1) {
    return _c("el-col", {
      key: index1,
      attrs: {
        span: _vm.item2.sortWay.type === "TRANSVERSE" ? Math.floor(24 / _vm.item2.sortWay.value) : 24
      }
    }, [_c("el-radio", {
      staticStyle: {
        "white-space": "pre-wrap",
        "vertical-align": "middle"
      },
      attrs: {
        label: item1.name
      },
      model: {
        value: _vm.item2.selectedOption,
        callback: function ($$v) {
          _vm.$set(_vm.item2, "selectedOption", $$v);
        },
        expression: "item2.selectedOption"
      }
    }, [_vm._v(_vm._s(item1.name))]), item1.isWrite && (item1.name === _vm.item2.selectedOption || item1.showInput) ? _c("el-input", {
      staticStyle: {
        width: "60px",
        height: "100%",
        "vertical-align": "middle"
      },
      attrs: {
        size: "small"
      },
      model: {
        value: _vm.item2.emptyValue,
        callback: function ($$v) {
          _vm.$set(_vm.item2, "emptyValue", $$v);
        },
        expression: "item2.emptyValue"
      }
    }) : _vm._e()], 1);
  }), 1)], 1) : _vm._e(), _vm.item2.partsType === "multipleChoice" ? _c("div", {
    staticClass: "nameBox"
  }, [_vm.item2.isRequired ? _c("span", {
    staticClass: "itamNav"
  }, [_vm._v("*")]) : _vm._e(), _vm._v(_vm._s(_vm.$t(_vm.item2.controlName)) + " "), _c("a-tooltip", [_c("template", {
    slot: "title"
  }, [_vm._v(" " + _vm._s(_vm.$t(_vm.item2.controlExplain)) + " ")]), _vm.item2.controlExplain ? _c("a-icon", {
    staticStyle: {
      margin: "0 3px"
    },
    attrs: {
      type: "question-circle"
    }
  }) : _vm._e()], 2), _c("div", [_c("el-row", {
    staticStyle: {
      "line-height": "40px"
    },
    attrs: {
      gutter: 20
    }
  }, _vm._l(_vm.item2.controlValue, function (item) {
    return _c("el-col", {
      key: item.name,
      attrs: {
        value: item.name,
        span: _vm.item2.sortWay.type === "TRANSVERSE" ? Math.floor(24 / _vm.item2.sortWay.value) : 24
      }
    }, [_c("el-checkbox", {
      staticStyle: {
        height: "40px",
        "vertical-align": "middle"
      },
      attrs: {
        label: item.name
      },
      model: {
        value: _vm.item2.selectedOptionsDX,
        callback: function ($$v) {
          _vm.$set(_vm.item2, "selectedOptionsDX", $$v);
        },
        expression: "item2.selectedOptionsDX"
      }
    }, [_vm._v(" " + _vm._s(item.name) + " ")]), item.isWrite && _vm.item2.selectedOptionsDX && _vm.item2.selectedOptionsDX.includes(item.name) ? _c("el-input", {
      staticStyle: {
        width: "60px",
        height: "100%",
        "vertical-align": "middle"
      },
      attrs: {
        size: "small"
      },
      model: {
        value: item.emptyValue,
        callback: function ($$v) {
          _vm.$set(item, "emptyValue", $$v);
        },
        expression: "item.emptyValue"
      }
    }) : _vm._e()], 1);
  }), 1)], 1)], 1) : _vm._e(), _vm.item2.partsType === "dropDown" ? _c("div", {
    staticClass: "nameBox"
  }, [_vm.item2.isRequired ? _c("span", {
    staticClass: "itamNav"
  }, [_vm._v("*")]) : _vm._e(), _vm._v(_vm._s(_vm.$t(_vm.item2.controlName)) + " "), _c("a-tooltip", [_c("template", {
    slot: "title"
  }, [_vm._v(" " + _vm._s(_vm.$t(_vm.item2.controlExplain)) + " ")]), _vm.item2.controlExplain ? _c("a-icon", {
    staticStyle: {
      margin: "0 3px"
    },
    attrs: {
      type: "question-circle"
    }
  }) : _vm._e()], 2), _c("div", [_c("el-cascader", {
    style: {
      width: _vm.item2.widthSet
    },
    attrs: {
      placeholder: _vm.$t("请选择"),
      options: _vm.item2.Customvalues,
      multiple: _vm.item2.isMultipleChoice,
      props: _vm.propsTree
    }
  })], 1)], 1) : _vm.item2.partsType === "enclosure" ? _c("div", {
    staticClass: "nameBox"
  }, [_vm.item2.isRequired ? _c("span", {
    staticClass: "itamNav"
  }, [_vm._v("*")]) : _vm._e(), _vm._v(_vm._s(_vm.$t(_vm.item2.controlName)) + " "), _c("a-tooltip", [_c("template", {
    slot: "title"
  }, [_vm._v(" " + _vm._s(_vm.$t(_vm.item2.controlExplain)) + " ")]), _vm.item2.controlExplain ? _c("a-icon", {
    staticStyle: {
      margin: "0 3px"
    },
    attrs: {
      type: "question-circle"
    }
  }) : _vm._e()], 2), _c("div", {
    staticClass: "pictureBox"
  }, [_c("div", {
    staticClass: "ant-upload ant-upload-select ant-upload-select-picture-card picture"
  }, [_c("a-icon", {
    attrs: {
      type: "plus"
    }
  })], 1), _vm.item2.fileFormat.length != 0 ? _c("div", [_vm._v("*" + _vm._s(_vm.$t("文件格式")) + "（" + _vm._s(_vm.item2.fileFormat.join(",")) + "）")]) : _vm._e(), _vm.item2.fileListData.length != 0 ? _c("div", [_vm._v(_vm._s(_vm.$t("模板预览")))]) : _vm._e()])], 1) : _vm.item2.partsType === "date" ? _c("div", {
    staticClass: "nameBox"
  }, [_vm.item2.isRequired ? _c("span", {
    staticClass: "itamNav"
  }, [_vm._v("*")]) : _vm._e(), _vm._v(_vm._s(_vm.$t(_vm.item2.controlName)) + " "), _c("a-tooltip", [_c("template", {
    slot: "title"
  }, [_vm._v(" " + _vm._s(_vm.$t(_vm.item2.controlExplain)) + " ")]), _vm.item2.controlExplain ? _c("a-icon", {
    staticStyle: {
      margin: "0 3px"
    },
    attrs: {
      type: "question-circle"
    }
  }) : _vm._e()], 2), _c("div", [_c("a-input", {
    style: {
      width: _vm.item2.widthSet
    },
    attrs: {
      placeholder: _vm.$t(_vm.item2.promptText),
      readOnly: true
    }
  })], 1)], 1) : _vm.item2.partsType === "sign" ? _c("div", {
    staticClass: "nameBox"
  }, [_vm.item2.url == "" ? _c("div", {
    staticClass: "Qm_box_a"
  }, [_c("div", {
    staticClass: "singn_tit"
  }, [_vm._v(_vm._s(_vm.$t("请在下方空白区域进行签名动作，完成签名后点击[上传]按钮")))]), _c("div", {
    staticClass: "QM_tit"
  }, [_vm._v(_vm._s(_vm.$t("签名区")))]), _c("div", {
    staticClass: "but_box"
  }, [_c("a-button", {
    attrs: {
      disabled: ""
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("取消")) + " ")]), _c("a-button", {
    staticStyle: {
      "background-color": "#1890ff",
      color: "#fff"
    },
    attrs: {
      disabled: "",
      type: "primary"
    }
  }, [_vm._v(_vm._s(_vm.$t("上传")) + " ")])], 1)]) : _vm._e()]) : _vm.item2.partsType === "paragraph" ? _c("div", {
    staticClass: "nameBox"
  }, [_c("div", {
    staticClass: "paragraphstyle",
    style: {
      width: _vm.item2.widthSet
    },
    domProps: {
      innerHTML: _vm._s(_vm.item2.content)
    }
  })]) : _vm.item2.partsType === "table" ? _c("div", {
    staticClass: "nameBox"
  }, [_c("table-control", {
    attrs: {
      index: _vm.tableIndex,
      containerTemplateId: _vm.item2.containerTemplateId,
      containerTemplateInfo: _vm.item2.containerTemplateInfo
    }
  })], 1) : _vm.item2.partsType === "estimate" ? _c("div", {
    staticClass: "nameBox"
  }, [_vm.item2.isRequired ? _c("span", {
    staticClass: "itamNav"
  }, [_vm._v("*")]) : _vm._e(), _vm._v(_vm._s(_vm.$t(_vm.item2.controlName)) + " "), _c("a-tooltip", [_c("template", {
    slot: "title"
  }, [_vm._v(" " + _vm._s(_vm.$t(_vm.item2.controlExplain)) + " ")]), _vm.item2.controlExplain ? _c("a-icon", {
    staticStyle: {
      margin: "0 3px"
    },
    attrs: {
      type: "question-circle"
    }
  }) : _vm._e()], 2), _c("div", [_c("a-input", {
    style: {
      width: _vm.item2.widthSet
    },
    attrs: {
      placeholder: _vm.$t(_vm.item2.promptText),
      readOnly: true
    }
  }), _vm._v("   " + _vm._s(_vm.$t(_vm.i18nCurrencyUnit(_vm.$store.state.user.accountInfo.customerId))) + "   ")], 1)], 1) : _vm.item2.partsType === "payment" ? _c("div", {
    staticClass: "nameBox"
  }, [_vm.item2.isRequired ? _c("span", {
    staticClass: "itamNav"
  }, [_vm._v("*")]) : _vm._e(), _vm._v(_vm._s(_vm.$t(_vm.item2.controlName)) + " "), _c("a-tooltip", [_c("template", {
    slot: "title"
  }, [_vm._v(" " + _vm._s(_vm.$t(_vm.item2.controlExplain)) + " ")]), _vm.item2.controlExplain ? _c("a-icon", {
    staticStyle: {
      margin: "0 3px"
    },
    attrs: {
      type: "question-circle"
    }
  }) : _vm._e()], 2), _c("div", [_c("a-input", {
    style: {
      width: _vm.item2.widthSet
    },
    attrs: {
      placeholder: _vm.$t(_vm.item2.promptText),
      readOnly: true
    }
  }), _vm._v("   " + _vm._s(_vm.$t(_vm.i18nCurrencyUnit(_vm.$store.state.user.accountInfo.customerId))) + "   ")], 1)], 1) : _vm._e()])]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };